module.exports = __webpack_public_path__ + "static/media/bg.2c0b9b7c.png";